function isBlockedBuyItAgainProduct(item)
{
    var blocked = false;
    var i       = 0;
    var variant = null;

    if (item)
    {
        if ( HasBuyAgainBlockedTags( item ) )
        {
            blocked = true;
        }

        if ( IsBlockedBuyAgainSku( item.sku ) )
        {
            blocked = true;
        }

        if (item.variants)
        {
            for (i = 0; i < item.variants.length; i++)
            {
                variant = item.variants[i];

                if (variant && IsBlockedBuyAgainSku(variant.sku))
                {
                    blocked = true;
                }
            }
        }
    }

    return blocked;
}

function sortPurchasedProducts(orderData)
{
    const products = {};
    var i           = 0;
    var item        = null;

    for (i = 0; i < orderData.orders.length; i++)
    {
        item = orderData.orders[i];

        if ( IsBuyAgainProductEligible( item ) && !isBlockedBuyItAgainProduct(item) )
        {
            if (!products[item.handle])
            {
                products[item.handle] = { data: item, totalQty: 0 };
            }

            products[item.handle].totalQty += item.qty;
        }
    }

    const sorted  = [];
    var   handles = "";

    for (handles in products)
    {
        sorted.push(products[handles]);
    }

    sorted.sort(function SortByFrequency(a, b)
    {
        return b.totalQty - a.totalQty;
    });

    return sorted;
}

function adaptOrderItemToProductCard(item)
{
    var price = parseFloat(item.price) / 100;
    var compareAt = item.compare_at_price ? parseFloat(item.compare_at_price) / 100 : null;

    var variants = item.variants;
    if (variants && variants.length > 0)
    {
        variants = variants.map(function adaptVariant(v)
        {
            return {
                id:                v.id,
                price:             (parseFloat(v.price) / 100).toFixed(2),
                compare_at_price:  v.compare_at_price ? (parseFloat(v.compare_at_price) / 100).toFixed(2) : null,
                available:         v.available,
                sku:               v.sku || item.sku || ""
            };
        });
    }
    else
    {
        variants = [{
            id:                item.default_variant_id,
            price:             price.toFixed(2),
            compare_at_price:  compareAt ? compareAt.toFixed(2) : null,
            available:         item.available,
            sku:               item.sku || ""
        }];
    }

    return {
        handle:  item.handle,
        title:   item.title,
        vendor:  item.vendor,
        images:  item.featured_image ? [{ src: item.featured_image }] : [],
        variants: variants,
        tags: item.tags || [],
        sku: item.sku || ""
    };
}

var buyItAgainHiddenIds = null;

function renderBuyItAgainCards(sorted, container, limit)
{
    const track = container.querySelector("[data-buy-it-again-track]");
    var   html  = "";
    var   i     = 0;

    // Frozen first-load snapshot: items already in the cart stay hidden on
    // every render (same as Members Love). Items added after load are not
    // in the snapshot, so they keep their card and flip to the qty stepper.
    if (buyItAgainHiddenIds == null)
    {
        buyItAgainHiddenIds = [];
        var cartItems = getCartItems();
        for (var ci = 0; ci < cartItems.length; ci++)
        {
            buyItAgainHiddenIds.push(String(cartItems[ci].variant_id));
        }
    }

    var displayed = 0;

    for (i = 0; i < sorted.length && displayed < limit; i++)
    {
        var firstVariantId = sorted[i].data.variants && sorted[i].data.variants.length > 0 ? String(sorted[i].data.variants[0].id) : "";
        if (firstVariantId && buyItAgainHiddenIds.indexOf(firstVariantId) != -1)
        {
            continue;
        }

        var product = adaptOrderItemToProductCard(sorted[i].data);

        if (!isBlockedBuyItAgainProduct(product))
        {
            html += renderHealthyHomeProductCard(product, []);
            displayed++;
        }
    }

    track.innerHTML = html;

    bindAtcButtons(track);
    checkCartQtyState(track);
}

function initBuyItAgain()
{
    const container = document.querySelector("[data-cart-buy-it-again]");
    if (!container) return;

    const orderScript = document.querySelector("[data-customer-orders-cart]");
    if (!orderScript) return;

    const orderData = JSON.parse(orderScript.textContent);
    const limit     = parseInt(container.getAttribute("data-limit"), 10) || 12;
    const sorted    = sortPurchasedProducts(orderData);

    renderBuyItAgainCards(sorted, container, limit);
}

document.addEventListener("DOMContentLoaded", initBuyItAgain);
